import { render, staticRenderFns } from "./InsuranceAncillaries.vue?vue&type=template&id=91a40bc0&scoped=true&"
import script from "./InsuranceAncillaries.vue?vue&type=script&lang=js&"
export * from "./InsuranceAncillaries.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceAncillaries.vue?vue&type=style&index=0&id=91a40bc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a40bc0",
  null
  
)

export default component.exports